import React, { useRef, ChangeEvent, PropsWithChildren } from "react";
import { useIntl } from "react-intl";

import { DropdownPopper } from "src/app/components/DropdownPopper/DropdownPopper";
import { ReactComponent as TickIcon } from "src/images/tick.svg";
import {
  DropdownMenu,
  DropdownMenuItem,
} from "src/app/components/Dropdown/Dropdown";
import CustomInput from "src/app/components/CustomInput/CustomInput";
import { translateMessage } from "src/app/methods/translateMessage";
import { Placement } from "react-overlays/cjs/usePopper";

interface SortOption {
  name: string;
  uuid: string;
}

interface SortDropdownProps {
  options: SortOption[];
  sortBy: string;
  handleClick: (newSortBy: string | null) => void;
  dropdownMenuClassName?: string;
  inputValue?: string;
  onInputChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  dropdownPlacement?: Placement;
}

export default function SortDropdown({
  options,
  sortBy,
  handleClick,
  dropdownMenuClassName,
  inputValue,
  onInputChange,
  children,
  dropdownPlacement,
}: PropsWithChildren<SortDropdownProps>) {
  const intl = useIntl();
  const dropdownRef = useRef<{ forceVisible: (state: boolean) => void }>();

  const showInput = inputValue !== undefined && onInputChange !== undefined;

  return (
    // @ts-ignore
    <DropdownPopper
      overlay={
        <DropdownMenu isOpen className={dropdownMenuClassName}>
          {showInput && (
            <CustomInput
              type="text"
              placeholder={translateMessage({
                intl,
                id: "ws_enter_field_name",
                defaultMessage: "Enter field name",
              })}
              value={inputValue}
              onChange={onInputChange}
            />
          )}
          <div className="dropdown__menu-list">
            {options.map((f) => {
              const active = sortBy === f.uuid;
              return (
                <DropdownMenuItem
                  key={f.uuid}
                  onClick={() => {
                    handleClick(active ? null : f.uuid);
                    if (dropdownRef.current) {
                      dropdownRef.current.forceVisible(false);
                    }
                  }}
                  data-qa={f.name}
                >
                  {f.name}
                  {active && <TickIcon />}
                </DropdownMenuItem>
              );
            })}
          </div>
        </DropdownMenu>
      }
      ref={dropdownRef}
      placement={dropdownPlacement}
    >
      {children}
    </DropdownPopper>
  );
}
